import { truthyFilter } from "./truthyFilter";
import { TruthyFilter } from "./types/truthyFilter";

// takes an array of candidate classes (conditional or optional strings) and combines any that are not falsy
export function getClassName(...args: Array<TruthyFilter<string>>) {
  return truthyFilter(...args).join(" ");
}
